// `movers`/`sitters` are the event's checked-in signup ID lists. `moversQueue`/
// `sittersQueue` are the ID lists frozen into the queue when it was generated —
// both live queue builders (buildGeneratedQueue's mixer branch and
// generateMutualMatchQueue) store plain userID STRINGS, so these diffs must
// compare raw IDs. Matching on anything else (e.g. a `.userID` field) silently
// matches nothing, which reads as "everyone just joined" / "everyone just left".
// Mixer queues have no `movers` list at all, hence the `|| []` defaults.

export const getRemovedUsers = (movers, sitters, moversQueue, sittersQueue) => ({
  movers: (moversQueue || []).filter(
    (userID) => userID && !(movers || []).includes(userID)
  ),
  sitters: (sittersQueue || []).filter(
    (userID) => userID && !(sitters || []).includes(userID)
  ),
});

export const getAddedUsers = (movers, sitters, moversQueue, sittersQueue) => {
  const queuedMoverIDs = new Set(moversQueue || []);
  const queuedSitterIDs = new Set(sittersQueue || []);

  return {
    movers: (movers || []).filter((userID) => !queuedMoverIDs.has(userID)),
    sitters: (sitters || []).filter((userID) => !queuedSitterIDs.has(userID)),
  };
};
